import { render, staticRenderFns } from "./register-agreement.vue?vue&type=template&id=7d6daa96&scoped=true&"
import script from "./register-agreement.vue?vue&type=script&lang=js&"
export * from "./register-agreement.vue?vue&type=script&lang=js&"
import style0 from "./register-agreement.vue?vue&type=style&index=0&id=7d6daa96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6daa96",
  null
  
)

export default component.exports